/**
 * Project chrome that survives Issues → Files (and every other tab).
 *
 * Each Mission page used to mount its own <AppShell>, which remounted
 * useAgent / useAgentChat and dropped the Think WebSocket. Official
 * useAgent must live above the route outlet.
 * https://developers.cloudflare.com/agents/api-reference/calling-agents/
 */
import { AppShellFrame, ProjectChromeProvider } from "@/components/app-shell";
import { ProjectScopeProvider } from "@/lib/project-scope";
import { Outlet } from "react-router-dom";

export function ProjectLayout() {
  return (
    <ProjectScopeProvider>
      <ProjectChromeProvider>
        <AppShellFrame>
          <Outlet />
        </AppShellFrame>
      </ProjectChromeProvider>
    </ProjectScopeProvider>
  );
}
